import React from 'react';
import OutsourceList from '../components/OutsourceList';
import PageHeader from '../components/common/PageHeader';
import PageContainer from '../components/common/PageContainer';

function Outsource() {
  return (
    <PageContainer>
      <PageHeader title="外注先管理" />
      <OutsourceList />
    </PageContainer>
  );
}

export default Outsource;
